$(document).ready(function(){
  // Banner slider
  $('.bannerSlide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: 'linear',
    focusOnSelect: false,
    pauseOnHover:false
  });
  // Banner slider

  // Team member slider
  $('.infoSlide_for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    cssEase: 'linear',
    asNavFor: '.imgSlide_nav',
    prevArrow:"<button type='button' class='slick-prev pull_left'><img src='https://cdn.shopify.com/s/files/1/0655/0057/7973/files/left-arrow-svgrepo-com.svg?v=1721985885'/></button>",
    nextArrow:"<button type='button' class='slick-next pull_right'><img src='https://cdn.shopify.com/s/files/1/0655/0057/7973/files/right-arrow-svgrepo-com.svg?v=1721985885'/></button>"
  });
  $('.imgSlide_nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.infoSlide_for',
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Team member slider
});

